"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _button = require("../button");
var _Banner = _interopRequireDefault(require("./Banner.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Banner = /*#__PURE__*/function (_React$Component) {
  _inherits(Banner, _React$Component);
  var _super = _createSuper(Banner);
  function Banner() {
    _classCallCheck(this, Banner);
    return _super.apply(this, arguments);
  }
  _createClass(Banner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      if (!(0, _utils.isBlank)(this.props.autoHideTime)) {
        this.timeoutReference = setTimeout(function () {
          _this.props.closeTrigger();
        }, this.props.autoHideTime);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeoutReference) {
        clearTimeout(this.timeoutReference);
        this.timeoutReference = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        autoHideTime = _this$props.autoHideTime,
        children = _this$props.children,
        closable = _this$props.closable,
        id = _this$props.id,
        type = _this$props.type,
        className = _this$props.className;
      var icon;
      switch (type) {
        case 'success':
          icon = 'ion-checkmark-circled';
          break;
        case 'error':
          icon = 'ion-close-circled';
          break;
        case 'info':
          icon = 'ion-ios-bell';
          break;
        case 'warning':
        default:
          icon = 'ion-android-alert';
          break;
      }
      return /*#__PURE__*/_react["default"].createElement(_Banner["default"], {
        autoHideTime: autoHideTime,
        closable: closable,
        "data-type": type,
        type: type,
        id: id,
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "banner-icon icon",
        icon: icon,
        size: 24
      }), children, closable && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "banner-dismiss-button",
        action: function action() {
          return _this2.props.closeTrigger();
        },
        type: "link"
      }, "Dismiss"));
    }
  }]);
  return Banner;
}(_react["default"].Component);
Banner.propTypes = {
  /** Time to display the banner in case it should autohide in miliseconds */
  autoHideTime: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /** Text or html to be displayed inside the banner */
  children: _propTypes["default"].node.isRequired,
  /** Flag to indicate wheather the banner should have a button to close */
  closable: _propTypes["default"].bool,
  /** Html id attribute for the element */
  id: _propTypes["default"].string,
  /** The type of the notification banner (eg. success, error, info) */
  type: _propTypes["default"].oneOf(['success', 'error', 'warning', 'info']).isRequired,
  /** an action to do when closing the banner */
  closeTrigger: _propTypes["default"].func,
  /** Html class attribute for the element */
  className: _propTypes["default"].string
};
Banner.defaultProps = {
  closeTrigger: function closeTrigger() {},
  autoHideTime: undefined,
  id: 'notificationBanner',
  closable: true,
  className: 'notification-banner'
};
Banner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Banner",
  "props": {
    "closeTrigger": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "an action to do when closing the banner",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "autoHideTime": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Time to display the banner in case it should autohide in miliseconds",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "'notificationBanner'",
        "computed": false
      },
      "description": "Html id attribute for the element",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "closable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Flag to indicate wheather the banner should have a button to close",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'notification-banner'",
        "computed": false
      },
      "description": "Html class attribute for the element",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "Text or html to be displayed inside the banner",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "type": {
      "description": "The type of the notification banner (eg. success, error, info)",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'success'",
          "computed": false
        }, {
          "value": "'error'",
          "computed": false
        }, {
          "value": "'warning'",
          "computed": false
        }, {
          "value": "'info'",
          "computed": false
        }]
      },
      "required": true
    }
  }
};
var _default = Banner;
exports["default"] = _default;